<template>
    <div class="header-container">
      <header class="header-bar">
        <div class="logo-container">
          <router-link to="/home">
            <img src="@/assets/Ansable.svg" alt="Logo" class="logo">
          </router-link>
        </div>
        <div class="logo-container dropdown-container">
          <button class="settings-button" @click="toggleDropdown">
            <img src="@/assets/Gear_Light.svg" alt="Settings" 
                 class="settings-icon"
                 :class="{ 'spinning-right': isSpinning && isOpeningMenu, 
                    'spinning-left': isSpinning && !isOpeningMenu }">
          </button>
          <div class="dropdown-menu" v-if="showMenu" :class="{ 'closing': isClosing }" @animationend="handleAnimationEnd">
            <!-- <div class="dropdown-item" @click="$router.push('/search')">
              <img src="@/assets/search icon.svg" alt="Search" class="menu-icon">
            </div> -->
            <div class="dropdown-item" @click="$router.push('/settings')">
              <img src="@/assets/Profile Icon.svg" alt="Profile" class="menu-icon">
            </div>
            <div class="dropdown-item" @click="handleLogout">
              <img src="@/assets/logout icon.svg" alt="Logout" class="menu-icon">
            </div>
          </div>
        </div>
      </header>
    </div>
  </template>
  
  <script>
    import { signOut } from 'firebase/auth';
    import { auth } from '@/firebase';
    import { useRouter } from 'vue-router';

  export default {
    name: 'HeaderBar',
    setup() {
        const router = useRouter();
        return { router };
    },
    data() {
      return {
        isSpinning: false,
        isDropdownOpen: false,
        isOpeningMenu: true,
        showMenu: false,
        isClosing: false
      }
    },
    methods: {
        toggleDropdown() {
            this.isSpinning = true;
            this.isOpeningMenu = !this.isDropdownOpen;
            
            if (this.isOpeningMenu) {
                // Opening the menu
                this.showMenu = true;
                this.isClosing = false;
            } else {
                // Closing the menu
                this.isClosing = true;
                setTimeout(() => {
                this.showMenu = false;
                }, 300); // Slightly shorter than the animation to ensure smooth transition
            }

            setTimeout(() => {
                this.isSpinning = false;
                this.isDropdownOpen = !this.isDropdownOpen;
            }, 300);
        },
        handleAnimationEnd() {
            if (this.isClosing) {
                this.showMenu = false;
            }
        },
        async handleLogout() {
            try {
                await signOut(auth);
                this.router.push('/'); // Redirect to login/home page
            } catch (error) {
                console.error('Error signing out:', error);
            }
        }
    }
    }
  </script>
  
  <style scoped>
  .header-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }
  
  .header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 10px;
    background-color: #fffff8;
    position: sticky;
    top: 0;
    z-index: 10;
    height: 64px;
  }
  
  .logo-container {
    display: flex;
    align-items: center;
  }
  
  .logo {
    max-height: 50px;
    padding-top: 7px;
  }
  
  /* Got to reset my button styles */
  .settings-button {
        background: none;
        border: none;
        padding: 0;
        display: flex;
        align-items: center;
    }

  .settings-icon{
        max-height: 50px;
        cursor: pointer;
        transform-origin: center center;
    }

    @keyframes spinRight {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(380deg);
        }
    }

    @keyframes spinLeft {
        from {
            transform: rotate(380deg);
        }
        to {
            transform: rotate(0deg);
        }
    }

    .spinning-right {
    animation: spinRight .5s ease-out;
    }

    .spinning-left {
        animation: spinLeft .5s ease-out;
    }

    @keyframes expandDown {
        from {
            transform-origin: top;
            transform: scaleY(0);
            max-height: 0;
        }
        to {
            transform-origin: top;
            transform: scaleY(1);
            max-height: 120px; /* Adjust based on your menu height */
        }
    }

    @keyframes contractUp {
        from {
            transform-origin: top;
            transform: scaleY(1);
            max-height: 120px;
        }
        to {
            transform-origin: top;
            transform: scaleY(0);
            max-height: 0;
        }
    }

    .dropdown-container {
        position: relative;
    }

    .dropdown-menu {
        position: absolute;
        top: 50px; /* Adjusted to account for header padding */
        background-color: #fffff8;
        border: 1px solid #545051;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        animation: expandDown .3s ease-out;
        transform-origin: top;
        overflow: hidden;
    }

    .dropdown-menu.closing {
        animation: contractUp .3s ease-out;
    }

    .dropdown-item {
        width: 37px;
        height: 40px;
        display: flex;  
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .menu-icon {
        width: 35px;
        height: 35px;
    }

    /* Add hover effect */
    .dropdown-item:hover {
        background-color: rgba(84, 80, 81, 0.1);
    }
  
  
  </style>